import './input-overrides.css';
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { SessionRequestProvider } from './contexts/SessionRequestContext';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './lib/toast';
import LoginPage from './components/LoginPage';
import PasswordResetPage from './components/PasswordResetPage';
import ProtectedRoute from './components/ProtectedRoute';
import theme from './theme/theme';

// Lazy load heavy dashboards so initial bundle and first paint are faster
const EmployeeDashboard = lazy(() => import('./components/EmployeeDashboard'));
const AdminDashboard = lazy(() => import('./components/AdminDashboard'));
const EmployeeEngagement = lazy(() => import('./components/EmployeeEngagement'));

const inputWhiteBg = {
  '.MuiOutlinedInput-root': { backgroundColor: '#ffffff !important' },
  '.MuiOutlinedInput-root .MuiInputBase-input.MuiOutlinedInput-input': { backgroundColor: '#ffffff !important' },
  '.MuiFilledInput-root': { backgroundColor: '#ffffff !important' },
  '.MuiFilledInput-root .MuiInputBase-input': { backgroundColor: '#ffffff !important' },
  '.MuiInputBase-root': { backgroundColor: '#ffffff !important' },
  'input.MuiInputBase-input': { backgroundColor: '#ffffff !important' },
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles styles={inputWhiteBg} />
      <CssBaseline />
      <ToastProvider>
        <AuthProvider>
          <SessionRequestProvider>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <Suspense fallback={
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" sx={{ color: '#6b7280' }}>
                  <CircularProgress size={48} sx={{ color: '#114417DB', mb: 2 }} />
                  <Typography variant="body1">Loading...</Typography>
                </Box>
              }>
                <Routes>
                  <Route path="/" element={<Navigate to="/login" replace />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/reset-password" element={<PasswordResetPage />} />
                  <Route 
                    path="/employee-dashboard" 
                    element={
                      <ProtectedRoute requiredRole="employee">
                        <EmployeeDashboard />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin-dashboard" 
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <AdminDashboard />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/employee-engagement" 
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <EmployeeEngagement />
                      </ProtectedRoute>
                    } 
                  />
                </Routes>
              </Suspense>
            </Router>
          </SessionRequestProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;